// extracted by mini-css-extract-plugin
export default {"rowIng":"ingredient-list-item_rowIng__ZH1or","orderPrice2":"ingredient-list-item_orderPrice2__nuXIW"};